module.exports = __webpack_public_path__ + "img/sales4.bfed648f.jpg";